import { render, staticRenderFns } from "./AddEditClientForm.vue?vue&type=template&id=33714c8a&scoped=true"
import script from "./AddEditClientForm.vue?vue&type=script&lang=js"
export * from "./AddEditClientForm.vue?vue&type=script&lang=js"
import style0 from "./AddEditClientForm.vue?vue&type=style&index=0&id=33714c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33714c8a",
  null
  
)

export default component.exports